import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/video',
    name: 'Video',
    // route level code-splitting
    // this generates a separate chunk (video.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "video" */ '../views/Video/Index.vue')
  },
  {
    path: '/activity',
    name: 'Activity',
    // route level code-splitting
    // this generates a separate chunk (activity.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "activity" */ '../views/Activity/Index.vue')
  },
  {
    path: '/character',
    name: 'Character',
    // route level code-splitting
    // this generates a separate chunk (character.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "character" */ '../views/Character/Index.vue')
  },
  {
    path: '/calligraphy',
    name: 'Calligraphy',
    // route level code-splitting
    // this generates a separate chunk (calligraphy.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "calligraphy" */ '../views/Calligraphy/Index.vue')
  },
  {
    path: '/painting',
    name: 'Painting',
    // route level code-splitting
    // this generates a separate chunk (painting.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "painting" */ '../views/Painting/Index.vue')
  },
  {
    path: '/masterwork',
    name: 'Masterwork',
    // route level code-splitting
    // this generates a separate chunk (masterwork.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "masterwork" */ '../views/Masterwork/Index.vue')
  },
  {
    path: '/appreciate',
    name: 'Appreciate',
    // route level code-splitting
    // this generates a separate chunk (appreciate.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "appreciate" */ '../views/Appreciate/Index.vue')
  },
  {
    path: '/knowledge',
    name: 'Knowledge',
    // route level code-splitting
    // this generates a separate chunk (knowledge.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "knowledge" */ '../views/Knowledge/Index.vue')
  },
  {
    path: '/show',
    name: 'Show',
    // route level code-splitting
    // this generates a separate chunk (show.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "show" */ '../views/Show/Index.vue')
  },
  {
    path: '/a-detail',
    name: 'ArticleDetail',
    // route level code-splitting
    // this generates a separate chunk (detail.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "detail" */ '../views/Detail/ArticleDetail.vue')
  },
  {
    path: '/c-detail',
    name: 'CharacterDetail',
    // route level code-splitting
    // this generates a separate chunk (detail.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "detail" */ '../views/Detail/ChaDetail.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
